import React from "react";
import { CheckoutType, PopupCheckoutType } from "types";
import { ButtonCodeHeading } from "../ButtonCodeHeading";
import { ButtonStyle } from "../ButtonStyle";
import { CheckoutStyling } from "../CheckoutStyling";
import { hasX2CheckoutWithFullProbability } from "@/models/Seller";

interface StepThreeChooseDesignProps {
    checkoutType: CheckoutType;
    popupType: PopupCheckoutType;
    onChangePopup: (e: React.ChangeEvent<HTMLInputElement>) => void; // handlePopupTypeChange
}

export const StepThreeChooseDesign = ({
    checkoutType,
    popupType,
    onChangePopup: onChange,
}: StepThreeChooseDesignProps) => {
    return (
        <div className="flex h-full flex-row items-start space-x-2 py-8">
            <ButtonCodeHeading number={hasX2CheckoutWithFullProbability() ? 2 : 3}>
                Choose your design
                {hasX2CheckoutWithFullProbability() && <span> and color</span>}
                <div className="text-base font-normal leading-p1 text-gray-darker">
                    Xola will choose appropriate font and button colors to contrast with your website&apos;s base design
                    theme
                </div>
            </ButtonCodeHeading>
            <div className="flex w-full flex-col space-y-8">
                {(hasX2CheckoutWithFullProbability() || checkoutType === CheckoutType.EMBEDDED) && <CheckoutStyling />}
                {checkoutType === CheckoutType.POPUP && <ButtonStyle popupType={popupType} onChange={onChange} />}
            </div>
        </div>
    );
};
